import { srSpeak } from "./srSpeak";
import { focus } from "./focus";

otto.ally.assignNamespace({
  srSpeak,
  focus,
});
